import Bugsnag from '@bugsnag/js'
import crypto from 'crypto'
import { useRef } from 'react'

const useChat = () => {
  const chatScript = useRef(null)

  const initChat = (email) => {
    if (!chatScript.current) {
      chatScript.current = document.createElement('script')
      chatScript.current.src = 'https://chat-assets.frontapp.com/v1/chat.bundle.js'
      document.body.appendChild(chatScript.current)
    }

    chatScript.current.onload = async () => {
      const hmac = crypto.createHmac('sha256', 'da6f363be22ea849e6eba799064ab2f1')
      const userHash = hmac.update(`${email}`).digest('hex')
      window.FrontChat('init', {
        chatId: 'cb69cc018fa07f9470b0e2d8fc01db34',
        useDefaultLauncher: true,
        email,
        userHash
      })
    }
  }

  return initChat
}

const reloadApp = () => window.location.reload(false)

const isTheSelectMenuClicked = (event) => {
  return event.target.classList?.contains('react-select__option') ||
    event.target.classList?.contains('react-select__menu')
}

export {
  Bugsnag,
  useChat,
  reloadApp,
  isTheSelectMenuClicked
}
